import { createRoot } from 'react-dom/client'
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react";

import './index.css'
import "./locales/i18n.jsx"
import App from './App.jsx'
import { store, persistor }  from "./store";


const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error("Root element not found!");
} else {
  try {
    createRoot(rootElement).render(
        <Provider store={store}>
          <PersistGate persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
    )
  } catch (error) {
    console.error("Error rendering app:", error);
  }
}